import { render, staticRenderFns } from "./email-suppression.vue?vue&type=template&id=38df0787"
import script from "./email-suppression.vue?vue&type=script&lang=js"
export * from "./email-suppression.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports